import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import swal from 'sweetalert2';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isShowingExpiredAlert = false;

  constructor(private router: Router) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');

    const clonedReq = token
      ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      : req;

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.router.url !== '/login') {
          // Ocultar cualquier loader activo
          document.querySelectorAll('.loading-overlay').forEach((el: any) => el.style.display = 'none');

          if (!this.isShowingExpiredAlert) {
            this.isShowingExpiredAlert = true;
            sessionStorage.clear();

            swal.fire({
              title: 'Sesión expirada',
              text: 'Por favor vuelva a iniciar sesión.',
              icon: 'warning',
              confirmButtonText: 'Iniciar sesión',
              confirmButtonColor: '#3085d6',
              allowOutsideClick: false,
              allowEscapeKey: false
            }).then(() => {
              this.isShowingExpiredAlert = false;
              this.router.navigate(['/login']);
            });
          }
          return EMPTY;
        }

        return throwError(error);
      })
    );
  }
}

